if (!customElements.get('drag-scroll')) {
  customElements.define(
    'drag-scroll',
    class DragScroll extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('.slider') || this.firstElementChild;
        if (!this.scroller) return;
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
        // Only advertise the grab cursor while there is something to scroll.
        this.sync = () =>
          this.scroller.classList.toggle('is-draggable', this.scroller.scrollWidth > this.scroller.clientWidth + 1);
        this.sync();
        new ResizeObserver(this.sync).observe(this.scroller);

        this.scroller.addEventListener('pointerdown', this.onDown.bind(this));
        this.scroller.addEventListener('pointermove', this.onMove.bind(this));
        this.scroller.addEventListener('pointerup', this.onUp.bind(this));
        this.scroller.addEventListener('pointercancel', this.onUp.bind(this));
        this.scroller.addEventListener('dragstart', this.onNativeDragStart.bind(this));
        // Swallow the click after a real drag so cards don't navigate.
        this.scroller.addEventListener('click', this.onClick.bind(this), true);
      }

      onDown(e) {
        // Mouse only; touch/pen keep native scrolling. Skip if nothing overflows.
        if (e.pointerType !== 'mouse' || e.button !== 0 || this.scroller.scrollWidth <= this.scroller.clientWidth) return;
        cancelAnimationFrame(this.raf);
        this.down = true;
        this.dragging = false;
        this.suppressClick = false;
        this.pointerId = e.pointerId;
        this.startX = e.clientX;
        this.startLeft = this.scroller.scrollLeft;
        this.vx = 0;
      }

      onMove(e) {
        if (!this.down) return;
        if ((e.buttons & 1) === 0) {
          this.resetDragState();
          return;
        }

        const dx = e.clientX - this.startX;

        // Preserve the native click until movement proves this is an intentional drag.
        if (!this.dragging) {
          if (Math.abs(dx) <= 8) return;
          this.dragging = true;
          this.scroller.setPointerCapture(this.pointerId);
          this.scroller.classList.add('is-grabbing');
        }

        e.preventDefault();
        const left = this.startLeft - dx;
        this.vx = left - this.scroller.scrollLeft;
        this.scroller.scrollLeft = left;
      }

      onUp(e) {
        if (!this.down) return;
        const wasDragging = this.dragging;
        this.down = false;

        if (this.scroller.hasPointerCapture?.(this.pointerId)) {
          this.scroller.releasePointerCapture(this.pointerId);
        }

        if (!wasDragging) {
          this.resetDragState();
          return;
        }

        this.dragging = false;
        this.suppressClick = true;
        // A pointer-generated click is dispatched immediately after pointerup.
        // Clear the guard on the next task so keyboard/programmatic clicks remain unaffected.
        setTimeout(() => {
          this.suppressClick = false;
        }, 0);

        if (this.reduce.matches) {
          this.scroller.classList.remove('is-grabbing');
          return;
        }
        const glide = () => {
          this.scroller.scrollLeft += this.vx;
          this.vx *= 0.92;
          if (Math.abs(this.vx) > 0.5) this.raf = requestAnimationFrame(glide);
          else this.scroller.classList.remove('is-grabbing'); // snap settles here
        };
        glide();
      }

      onNativeDragStart(e) {
        if (this.down) e.preventDefault();
      }

      onClick(e) {
        if (!this.suppressClick) return;
        e.preventDefault();
        e.stopPropagation();
        this.suppressClick = false;
      }

      resetDragState() {
        this.down = false;
        this.dragging = false;
        this.scroller.classList.remove('is-grabbing');
      }
    }
  );
}
